module.exports = __webpack_public_path__ + "img/CALENDAR.94ad3b7b.svg";